import React from 'react';
import { cn, formatNumber, getTrendIndicator } from '../lib/utils';

export const KPICard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  icon: Icon, 
  variant = 'default',
  className 
}) => {
  const trendInfo = trend !== undefined ? getTrendIndicator(trend) : null;

  const variantClasses = {
    default: 'bg-white',
    primary: 'bg-gradient-to-br from-indigo-500 to-violet-600 text-white',
    success: 'bg-gradient-to-br from-emerald-500 to-teal-600 text-white',
    warning: 'bg-gradient-to-br from-amber-400 to-orange-500 text-white',
    danger: 'bg-gradient-to-br from-rose-500 to-pink-600 text-white',
  };

  const isColoredVariant = variant !== 'default';

  return (
    <div
      className={cn(
        'rounded-xl border shadow-sm p-6 transition-all duration-200 hover:shadow-md hover:-translate-y-0.5',
        variantClasses[variant],
        isColoredVariant ? 'border-transparent' : 'border-slate-200',
        className
      )}
      data-testid={`kpi-card-${title?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between mb-4">
        <p className={cn(
          'text-sm font-medium',
          isColoredVariant ? 'text-white/80' : 'text-slate-600'
        )}>
          {title}
        </p>
        {Icon && (
          <div className={cn(
            'w-10 h-10 rounded-lg flex items-center justify-center',
            isColoredVariant ? 'bg-white/20' : 'bg-slate-100'
          )}>
            <Icon className={cn(
              'w-5 h-5',
              isColoredVariant ? 'text-white' : 'text-slate-600'
            )} />
          </div>
        )}
      </div>

      <div className="flex items-end justify-between">
        <div>
          <p className={cn(
            'text-3xl font-bold tracking-tight',
            isColoredVariant ? 'text-white' : 'text-slate-900'
          )}>
            {typeof value === 'number' ? formatNumber(value) : value}
          </p>
          {subtitle && (
            <p className={cn(
              'text-sm mt-1',
              isColoredVariant ? 'text-white/70' : 'text-slate-500'
            )}>
              {subtitle}
            </p>
          )}
        </div>

        {trendInfo && (
          <div className={cn(
            'flex items-center gap-1 text-sm font-medium',
            isColoredVariant ? 'text-white/90' : trendInfo.color
          )}>
            <span>{trendInfo.icon}</span>
            <span>{Math.abs(trend).toFixed(1)}%</span>
          </div>
        )}
      </div>
    </div>
  );
};
